/* eslint-disable i18next/no-literal-string */
import React, { useCallback } from "react";
import styles from "./text-area.module.scss";
import classnames from "classnames";
import { Field, FieldProps, useFormikContext } from "formik";
import { observer } from "mobx-react-lite";
import type { FormTextAreaProps } from "@whatslly/types/UI-V2/FormElements/FormTextAreaType";
import { TextArea } from "@whatslly/ui-components/v2/BaseElements/TextArea";
import { Label } from "../../BaseElements/Label";
import globalStyles from "../../globalStyles";
import { FormFieldV2 } from "../FormField";

export const FormTextArea: React.FC<FormTextAreaProps> = observer(
  ({
    labelText,
    labelFontSize,
    labelFontWeight,
    labelColor,
    labelUnderLine,
    labelInline,
    paddingInline,
    marginBottom,
    marginTop,
    labelComment,
    className,
    onChange,
    name,
    required,
    ...props
  }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks, @typescript-eslint/no-explicit-any
    const formikContext = useFormikContext<Record<string, any>>();
    const formOnChange = useCallback(
      (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        formikContext.handleChange(e);
        if (onChange) {
          return onChange(e);
        }
      },
      [formikContext, onChange]
    );
    return (
      <FormFieldV2
        className={classnames(
          styles.textAreaContainer,
          globalStyles[`pi-${paddingInline ?? "default"}`],
          globalStyles[`d-${labelInline ? "flex" : ""}`],
          globalStyles[`flex-${labelInline ? "row" : ""}`],
          globalStyles[`mt-${marginTop}`],
          globalStyles[`mb-${marginBottom ?? "default"}`],
          globalStyles[`align-items-${labelInline ? "center" : ""}`],
          globalStyles[`justify-content-${labelInline ? "between" : ""}`]
        )}
        errorText={formikContext.errors[name] as string}
        showError={!!formikContext.errors[name] && !!formikContext.touched[name]}
      >
        {labelText && (
          <Label
            text={labelText}
            fontSize={labelFontSize}
            color={labelColor}
            marginBottom={labelInline ? "none" : "small"}
            underLine={labelUnderLine}
            comment={labelComment}
            fontWeight={labelFontWeight}
            required={required}
          />
        )}
        <Field
          type={props.type}
          placeholder={props.placeholder}
          onChange={formOnChange}
          children={(fieldData: FieldProps) => {
            const initialValue = fieldData.field.value[name];
            return <TextArea value={initialValue ?? ""} onChange={formOnChange} name={name} paddingInline="none" {...props} />;
          }}
          className={classnames(
            styles.FormtextInput,
            {
              [styles.inlineLabel]: labelInline,
            },
            className
          )}
          {...props}
        />
      </FormFieldV2>
    );
  }
);
